import { RoleType } from './role-types';
import {
  SessionActivityTimeOfDay,
  WorkTimeType,
} from './session-activity-types';
import { SessionDayType } from './session-types';

export enum EstimateStatus {
  Draft = 'Draft',
  Final = 'Final',
}

/**
 * Rate Multipliers
 */
export type TRateMultipliers = {
  [WorkTimeType.StraightTime]: number;
  [WorkTimeType.TimeAndOneHalf]: number;
  [WorkTimeType.DoubleTime]: number;
  [WorkTimeType.NoServiceDay]: number;
  [WorkTimeType.NoServiceDayWeekendHoliday]: number;
  [SessionDayType.Saturday]: number;
  [SessionDayType.Sunday]: number;
  [SessionDayType.Holiday]: number;
  [SessionActivityTimeOfDay.Night]: number;
  [SessionActivityTimeOfDay.LateNight]: number;
  [SessionActivityTimeOfDay.AfterMidnight]: number;
  [RoleType.CopyistSideMusician1Double]: number;
  [RoleType.CopyistSideMusician2Doubles]: number;
  [RoleType.CopyistSideMusician3Doubles]: number;
  [RoleType.CopyistSideMusician4Doubles]: number;
  [multiplierType: string]: number;
};

/**
 * The contract's values for an estimate item, as it was last priced. A value that differs from its default
 * was edited by hand.
 */
export type TItemDefaults = {
  rate: number;
  p_and_h_multiplier: number;
  handling_multiplier: number;
  taxes_multiplier: number;
};

export type TItemDefaultField =
  | 'rate'
  | 'p_and_h_multiplier'
  | 'handling_multiplier'
  | 'taxes_multiplier';
